<template>
  <div>
    <div class="modal__traffic-template-wrapper">
        <div v-if="modalData.last_status && modalData.last_status.avg_speed" class="modal__traffic-info-item">
          <div class="modal__traffic-info-label modal__subtitle">
              <translated-text-component translation="traffic_avg_speed" />:
          </div>
          <div class="modal__traffic-info-value">
              {{Math.round(modalData.last_status.avg_speed)}} km/h
          </div>
        </div>
        <div v-if="modalData.last_status && modalData.last_status.avg_time" class="modal__traffic-info-item">
          <div class="modal__traffic-info-label modal__subtitle">
              <translated-text-component translation="traffic_avg_time" />:
          </div>
          <div class="modal__traffic-info-value">
              {{avgTime}} min
          </div>
        </div>
        <div v-if="!modalData.last_status" class="modal__traffic-no-data">
          <translated-text-component translation="traffic_no_last_data" />
        </div>
    </div>
  </div>
</template>

<script lang="ts">
import {
  defineComponent, onMounted, Ref, ref, watch,
} from 'vue';
import { IModalData } from '@/services/layers/IModalData';
import moment from 'moment';

const TemplateModalTrafficLine: object = defineComponent({
  props: {
    templateData: {
      type: Object,
      required: true,
    },
  },
  name: 'TemplateModalTrafficLine',
  setup(props) {
    const modalData: Ref<any> = ref({});
    const avgTime: Ref<string> = ref(''); 

    onMounted(() => {
      const { metaData } = props.templateData;
      modalData.value = metaData;
      if (modalData.value.last_status && modalData.value.last_status.avg_time) {
        avgTime.value = moment.utc(modalData.value.last_status.avg_time * 1000).format('m:ss');
      }
    });

    return {
      modalData,
      avgTime,
    };
  },
});
export default TemplateModalTrafficLine;
</script>

<style scoped lang="scss">
.modal__traffic {
  &-info-item {
    margin-bottom: 7px;
    text-align: center;
  }

  &-info-label {
    font-size: rem(16px);
    font-weight: 700;
    margin-bottom: 5px;
  }

  &-no-data {
    font-size: rem(18px);
    text-align: center;
  }
}
</style>
